class Point {
  constructor(lat, lng) {
    this.lat = lat
    this.lng = lng
  }
}

export default {
  Point
}
